<template>
  <details class="control-settings academy-control" @toggle="onToggle">
    <summary>Fristen und Benachrichtigungen</summary>
    <v-progress-linear v-if="loading" indeterminate color="#58d388" class="mt-4" />
    <div v-if="form">
      <div v-if="area === 'reports'" class="control-fields">
        <v-select v-model="form.startPeriod" :items="periods" label="Startperiode" dark outlined :disabled="saving" />
        <v-combobox v-model="form.reminderDays" label="Erinnerungstage vor der Frist" :items="[0, 1, 3, 7, 14, 30]" multiple small-chips dark outlined :disabled="saving" hint="0 = am Fristtag; maximal sechs Werte von 0 bis 30." persistent-hint />
      </div>
      <v-alert v-if="area === 'reports' && !form.reportsConfigured" type="info" text>Die Reportpflicht ist noch nicht eingerichtet. Wähle die Startperiode; erst mit dem ersten Speichern werden die Abgabeperioden angelegt.</v-alert>
      <p v-if="area === 'reports'" class="control-note mt-3">Frist: letzter Freitag jedes ungeraden Monats, 23:59 Uhr Schweizer Zeit. Vorhandene Reports bleiben erhalten. Bei rückwirkendem Start werden fehlende Perioden mit der heutigen CL-Zuordnung angelegt.</p>
      <div class="control-fields">
        <v-switch v-model="form[area].push" dark inset color="#58d388" label="Push und App-Benachrichtigungen" :disabled="saving" />
        <v-switch v-model="form[area].email" dark inset color="#58d388" label="E-Mail-Benachrichtigungen" :disabled="saving" />
      </div>
      <p class="control-note">{{ area === 'reports' ? 'Gilt für Fristerinnerungen, neue Abgaben und Rückmeldungen. Erinnerungen gehen nur an CL mit ausstehenden oder zu überarbeitenden Reports.' : 'Neue Audit-Protokolle werden der Leadership-Kontaktperson gemeldet, ersatzweise der Leadership-Verwaltung. Interne Bewertungen werden nicht an Mitarbeitende versendet.' }}</p>
      <p class="control-note mt-2">Beide Kanäle sind unabhängig. Ausgeschaltete Kanäle versenden nichts; alte Nachrichten werden später nicht nachgeholt. Versandprüfung alle 15 Minuten.</p>
      <div class="control-actions"><v-btn color="#58d388" class="black--text" :loading="saving" :disabled="loading" @click="save">Einstellungen speichern</v-btn><span v-if="saved" class="control-note">Gespeichert</span></div>
    </div>
    <v-alert v-if="error" type="error" text class="mt-3">{{ error }}<v-btn v-if="!saving" text @click="load">Neu laden</v-btn></v-alert>
  </details>
</template>
<script>
import api from "@/api"
export default {
  props: { area: { type: String, required: true } },
  data: () => ({ form: null, loading: false, saving: false, error: "", saved: false }),
  computed: {
    periods() {
      const year = new Date().getFullYear(), result = []
      for (let value = year - 1; value <= year + 2; value++) for (const month of [1, 3, 5, 7, 9, 11]) result.push(`${value}-${String(month).padStart(2, "0")}`)
      if (this.form && !result.includes(this.form.startPeriod)) result.unshift(this.form.startPeriod)
      return result
    },
  },
  methods: {
    onToggle(event) { if (event.target.open && !this.form && !this.loading) this.load() },
    async load() {
      this.loading = true; this.error = ""
      try { this.form = await api.academyControl.settings() } catch (error) { this.error = "Einstellungen konnten nicht geladen werden." }
      finally { this.loading = false }
    },
    async save() {
      if (this.saving) return
      this.saving = true; this.error = ""; this.saved = false
      try {
        const reminderDays = this.form.reminderDays.map(value => typeof value === "number" ? value : /^\d+$/.test(String(value).trim()) ? Number(value) : NaN)
        if (reminderDays.some(value => !Number.isInteger(value) || value < 0 || value > 30) || reminderDays.length > 6) throw new Error("Bitte bis zu sechs ganze Zahlen von 0 bis 30 eingeben.")
        this.form = await api.academyControl.saveSettings({ ...this.form, area: this.area, reminderDays })
        this.saved = true; this.$emit("saved")
      } catch (error) { this.error = (error.response && error.response.data.error) || error.message || "Speichern fehlgeschlagen." }
      finally { this.saving = false }
    },
  },
}
</script>
<style scoped src="./control.css"></style>
